import TileLayer from "ol/layer/Tile";
import OSM from "ol/source/OSM";
import { WMTS, XYZ } from "ol/source";
import { default as OLMap } from "ol/Map";
import { useEffect, useRef, useState } from "react";
import { get as getProjection, transform } from "ol/proj.js";
import { View } from "ol";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { cloneDeep } from "lodash";
import { Interaction } from "ol/interaction";
import { Control } from "ol/control";
import store from "../../stores/store";
import { useSelector } from "react-redux";
import WMTSTileGrid from "ol/tilegrid/WMTS";
import { getTopLeft, getWidth } from "ol/extent";
import { getMapCenter, getMapProjection } from "./mapUtils";

function BaseLayerSwitcher() {
  const baselayers = function () {
    let basemaps = [
      new TileLayer({
        source: new OSM({ singleTile: true, ratio: 1 }),
        isBaseLayer: true,
        title: "OSM Topo",
        image: "./images/baselayer1.jpg",
        name: "openstreet",
      }),
      new TileLayer({
        source: new OSM({
          singleTile: true,
          ratio: 1,
          url: "//{a-c}.tile.geofabrik.de/15173cf79060ee4a66573954f6017ab0/{z}/{x}/{y}.png",
        }),
        isBaseLayer: true,
        title: "OSM Geofabrik",
      }),
      new TileLayer({
        source: new XYZ({
          url: "//mt0.google.com/vt/lyrs=m&hl=en&x={x}&y={y}&z={z}",
        }),
        isBaseLayer: true,
        title: "Google Roadmap",
        name: "google.roadmap",
      }),
      new TileLayer({
        source: new XYZ({
          url: "//mt0.google.com/vt/lyrs=p&hl=en&x={x}&y={y}&z={z}",
        }),
        isBaseLayer: true,
        title: "Google Altered Roadmap",
        name: "google.altered.roadmap",
      }),
      new TileLayer({
        source: new XYZ({
          url: "//mt0.google.com/vt/lyrs=s&hl=en&x={x}&y={y}&z={z}",
        }),
        isBaseLayer: true,
        title: "Google Satellite",
        name: "google.satellite",
      }),
      new TileLayer({
        source: new XYZ({
          url: "//mt0.google.com/vt/lyrs=t&hl=en&x={x}&y={y}&z={z}",
        }),
        isBaseLayer: true,
        title: "Google Terrain",
        name: "google.terrain",
      }),
    ];

    let _baselayers = [];

    if (window["appConfig"]()["basemaps"]) {
      window["appConfig"]()["basemaps"].forEach((basemap) => {
        basemaps?.forEach((el) => {
          if (el.get("name") === basemap) {
            _baselayers.push(el);
          }
        });

        if (basemap.type) {
          if (basemap.source) {
            if (basemap.source.type) {
              switch (basemap.source.type) {
                case "WMS":
                  break;

                case "WMTS":
                  const projection = getProjection(basemap.source.projection);
                  const projectionExtent = [
                    31668.0, 3713192.0, 1080244.0, 4761768.0,
                  ];

                  const size = getWidth(projectionExtent) / 256;

                  const resolutions = [];
                  for (let z = 0; z < basemap.source.matrixIds.length; ++z) {
                    resolutions.push(size / Math.pow(2, z));
                  }

                  _baselayers.push(
                    new TileLayer({
                      title: basemap.title,
                      source: new WMTS({
                        url: basemap.source.url,
                        layer: basemap.source.name,
                        matrixSet: basemap.source.matrixSet,
                        format: "image/png",
                        projection: basemap.source.projection,
                        tileGrid: new WMTSTileGrid({
                          origin: getTopLeft(projectionExtent),
                          resolutions: resolutions,
                          matrixIds: basemap.source.matrixIds,
                        }),
                      }),
                    })
                  );
                  break;
              }
            }
          }
        }
      });
    } else {
      _baselayers = basemaps;
    }

    return _baselayers;
  };

  let baseMapRefs = useRef([]);
  let mapBaseLayers = cloneDeep(baselayers());

  const activeBaselayer = useSelector(
    (state) => store.getState().map.activeBaseLayer
  );

  useEffect(() => {
    if (window["map"]) {
      baselayers().map((el, idx) => {
        if (el !== "cesium") {
          if (!idx) {
            window["map"].addLayer(mapBaseLayers[idx]);
          }

          let a = new OLMap({
            target: document.getElementById("baselayer-" + idx),
            layers: [el],
            view: new View({
              projection: getMapProjection(),
              center: getMapCenter(),
              zoom: 6,
            }),
            controls: [],
          });

          window["map"]?.on("moveend", () => {
            a.getView().setCenter(window["map"].getView().getCenter());
            a.getView().setZoom(window["map"].getView().getZoom());
          });
        }
      });
    }
  }, [window["map"]]);

  return (
    <div className="row flex-nowrap overflow-auto">
      {baselayers().map((el, idx) => {
        return (
          <div className="col-3 me-2">
            <div
              style={{ height: "10.5rem", width: "10.5rem" }}
              className="p-2"
              onClick={() => {
                window["map"].getLayers().forEach((el) => {
                  if (el?.get("isBaseLayer")) {
                    window["map"].removeLayer(el);
                  }
                });

                store.dispatch({ type: "map/setbaselayer", payload: idx });
                window["map"].addLayer(mapBaseLayers[idx]);
              }}
            >
              <div
                style={{ width: "8rem", height: "6.5rem" }}
                className={"m-auto ".concat(
                  activeBaselayer === idx
                    ? "border border-4 border-success text-white"
                    : ""
                )}
                ref={(el) => (baseMapRefs.current[idx] = el)}
                id={"baselayer-" + idx}
              ></div>
              <div
                className="text-center small"
                style={{ lineHeight: "normal" }}
              >
                {el.values_.title}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default BaseLayerSwitcher;
